export default {
  filterCommonLoading: "로딩 중...",
  filterCommonNoData: "데이터 없음",

  hiringLocation: "채용 위치",
  dateRange: "날짜 범위",
  marketGalleries: "갤러리",
  marketGalleriesPlaceholder: "갤러리 입력",
  marketCategories: "카테고리",
  marketCategoriesPlaceholder: "카테고리 입력",
  newsLocations: "뉴스 위치",
  publishedDateRange: "게시 날짜 범위",
  industryCategories: "산업 카테고리",
  industryCategoriesPlaceholder: "산업 카테고리 입력",
  industrySubCategories: "하위 산업 카테고리",
  sequencePlaceholder: "시퀀스 이름 입력",
  pageviewGreaterThan: "페이지뷰",
  sessionGreaterThan: "세션",
  advertisements: "광고",
  accountLocation: "계정 위치",
  startDate: "시작일",
  endDate: "종료일",
  inputNumberMin: "최소",
  inputNumberMax: "최대",
  postingLocation: "게시 위치",

  filterJob: "채용 검색",
  filterJobPostingDateSubTitle: "게시 날짜 기간",
  filterJobPostingLocation: "게시 위치",
  filterJobTitlesSubTitle: "직책",

  filterNews: "뉴스",
  filterNewsPublishedDateSubTitle: "게시 날짜 기간",
  filterNewsCategories: "카테고리",

  filterEmployeeCustomRange: "사용자 지정 범위",

  filterAdvancedSearch: "고급 검색",
  allSearchResultsFor: '"{count}"에 대한 모든 검색 결과',
  filterAdvancedSearchTooltip:
    "정확한 단어뿐만 아니라 의미를 통해 결과를 찾습니다.",

  filterSpecialties: "전문 분야",
  filterSpecialtiesPlaceHolder: "전문 분야 입력",

  filterIndustrySubCategories: "하위 산업",
  filterIndustrySubCategoriesPlaceHolder: "하위 산업 입력",

  filterAdPlaceholder: "광고 입력",

  filterEmployeesPlaceholder: "직원 선택",

  filterLocationExcludeText: "선택한 위치 제외",
  filterLocationExcludeTooltip:
    "활성화하면 이러한 위치가 결과에서 필터링됩니다.",
  filterManagementPlaceholder: "관리 레벨 입력",

  filterJobFunctionPlaceholder: "직무 입력",

  filterDepartmentPlaceholder: "부서 입력",

  filterPage: "페이지",
  filterPerPage: "페이지당 항목 수",

  filterCompanyPlaceHolder: "회사 입력",
  filterCompanyCSVImport: "이미 가지고 있는 회사 목록을 쉽게 가져오기",
  filterCompanyCSVText: "회사 목록 가져오기 (CSV)",

  csvComponentTitle1: "CSV 업로드",
  csvComponentTitle2: "업로드 검토",
  csvTipNeedHelp: "도움이 필요하세요?",
  detectFileNumber: "{count}개 회사 감지됨",
  uploadLoading: "업로드 중...",
  uploadReplace: "교체",
  noCompaniesWereDetectedInYourFile:
    "파일에서 회사가 감지되지 않았습니다. 데이터를 확인하고 다시 업로드해주세요.",
  fileContainsManyCompanies:
    "파일에 많은 회사가 포함되어 있습니다. 첫 {count}개만 사용됩니다.",
  onlyReturnOneResultPerCompany: "회사당 1개의 결과만 반환",
  btnViewCompanyList: "회사 목록 보기",
  csvFileAnalysisFailed:
    "CSV 파일 분석에 실패했습니다. 나중에 다시 시도해주세요.",
  downloadFailed: "다운로드에 실패했습니다. 다시 시도해주세요.",
  downloadSampleCsv: "샘플 CSV 다운로드",
  firstHundredEntriesWillBeProcessed: "파일당 첫 {count}개 항목만 처리됩니다.",
  detectingCompaniesInFile: "파일에서 회사 감지 중...",
  thisMayTakeAFewSeconds: "몇 초 정도 걸릴 수 있습니다.",

  filterSaveText: "검색 저장",
  filterClearAllText: "모두 지우기",

  filterRemoved: "필터가 제거되었습니다",
};
